import { TableCell, Theme, useMediaQuery } from "@mui/material"
import { useEffect, useState } from "react"
import { THEME } from "../../../config"
import { handleCutStringHelper, handleDate, handleNumberHelper, handleParseList, handleStringFromLastOccurrence, handleStringHelper, handleStringLengthHelper, selectHTTPColorHelper, selectStatusColorHelper } from "../../../helpers/displayStringHelpers"
import StyledTooltip from "../StyledTooltip"

interface DataTableCellProps {
    value: any,
    tooltipValue?: string,
    onClick?: () => void,
    align: "left" | "right"
    type: "number" | "string" | "date" | "longstring" | "type" | "status" | "liveness" | "HTTP" | "exceptionName" | "attack" | "decision" | "issue"
}

const DataTableCell: React.FC<DataTableCellProps> = (props) => {
    
    const [color, setColor] = useState(THEME.palette.text.primary)
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    useEffect(() => {
        if (props.type === "status")
            setColor(selectStatusColorHelper(props.value))
        if (props.type === "HTTP")
            setColor(selectHTTPColorHelper(props.value))
    }, [props.value, props.type])

    const handleValue = () => {
        switch (props.type) {
            case "number":
                return (props.value !== undefined? handleNumberHelper(props.value) : "-")
            case "string":
                return (props.value !== undefined? handleStringLengthHelper(props.value) : "-")
            case "date":
                return (props.value !== undefined? handleDate(props.value, isMobile) : "-")
            case "longstring":
                return (props.value !== undefined && props.value !== ""? props.value : "-")
            case "type":
                return handleStringHelper(props.value)
            case "status":
                return handleStringHelper(props.value)
            case "liveness":
                return handleStringHelper(props.value)
            case "attack":
                return handleCutStringHelper("ATTACK_", props.value)
            case "decision":
                return handleCutStringHelper("DECISION_", props.value)
            case "HTTP":
                return (props.value !== undefined? props.value : "-")
            case "exceptionName":
                return (props.value !== undefined? handleStringFromLastOccurrence(props.value, ".") : "-")
            case "issue":
                return handleParseList("ISSUE_", props.value)
        }
    }

    return (
        <StyledTooltip title={props.tooltipValue} enterDelay={1000} enterNextDelay={1000}>
            <TableCell
                onClick={props.onClick}
                align={props.align}
                style={{
                    color: color,
                    fontWeight: props.type === "status" || props.type === "HTTP" ? "500" : "400"
                }}
            >
                {handleValue()}
            </TableCell>
        </StyledTooltip>
    )
}

export default DataTableCell